module.exports = __webpack_public_path__ + "static/img/southeastAsia_sales.10996e30.png";